<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Regolazione primaria"
        v-model="implant.primary_regulation"
        :options="[
          'Sistema di regolazione ON - OFF',
          'Sistema di regolazione con impostazione della curva climatica integrata nel generatore',
          'Sistema di regolazione con impostazione della curva climatica indipendente',
          'Valvole di regolazione',
          'Sistema di regolazione multigradino',
          'Sistema di regolazione a inverter del generatore',
          'Altri sistemi di regolazione primaria'
        ]"
      />
    </div>

    <Sub title="Sistema di regolazione" tag="SR" v-model:elements="implant.regulation_systems" v-slot="slotProps" v-if="isIndependent" :codes="implant.codes">
      <RegulationSystem :element="slotProps.element" />
    </Sub>

    <Sub title="Valvole di regolazione" tag="VR" v-model:elements="implant.regulating_valves" v-slot="slotProps" v-if="isValves" :codes="implant.codes">
      <RegulationValve :element="slotProps.element" />
    </Sub>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="isOther">
      <InputTextarea name="Descrizione del sistema" v-model="implant.regulation_description" />
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Regolazione singolo ambiente di zona"
        v-model="implant.single_regulation"
        :options="[
          'Termostato di zona o ambiente con controllo ON - OFF',
          'Termostato di zona o ambiente con controllo proporzionale',
          'Controllo entalpico su serranda aria esterna',
          'Controllo portata aria variabile per aria canalizzata',
        ]"
      />
    </div>

    <Sub title="Valvole" v-model:elements="implant.valves" v-slot="slotProps" :codes="implant.codes">
      <Valve :element="slotProps.element" />
    </Sub>

    <!--
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Punti di regolazione" v-model="implant.regulation_system_adjustment_points" />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Livelli di temp." v-model="implant.regulation_system_temperature_levels" />
    </div>
    -->
  </div>
</template>
  
<script>
import RegulationSystem from './_5-regulation/regulation_system'
import RegulationValve from './_5-regulation/regulation_valve'
import Valve from './_5-regulation/valve'

export default {
  components: {
    RegulationSystem,
    RegulationValve,
    Valve
  },

  props: {
    implant: Object
  },
  emits: ['update:implant'],

  computed: {
    isIndependent() {
      return (
        this.implant.primary_regulation === 'Sistema di regolazione ON - OFF' ||
        this.implant.primary_regulation === 'Sistema di regolazione con impostazione della curva climatica integrata nel generatore' ||
        this.implant.primary_regulation === 'Sistema di regolazione con impostazione della curva climatica indipendente'
      )
    },
    isValves() {
      return this.implant.primary_regulation === 'Valvole di regolazione'
    },
    isOther() {
      return this.implant.primary_regulation === 'Altri sistemi di regolazione primaria'
    },
  }
}
</script>